import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const profileService = {
  getProfileDetails,
  putProfileDetails,
  getUserExperience,
  addUserExperience,
  updateUserExperience,
  deleteUserExperience,
  putInterest,
  removeInterests,
  addInterest,
  putProfilePicture,
  putProfilePopup,
  getUserEducation,
  addUserEducation,
  updateUserEducation,
  deleteUserEducation,
  getExpertiseList,
  updateExpertise,
  saveCoverPicture,
  getPromptList,
  addPrompt,
  updatePrompt,
  deletePrompt,
  likeOrDislikePrompt
}

let cancel
function getProfileDetails(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/get', requestOptions)
}

function putProfileDetails(key, value, ctaPopup) {
  const params = { key, value }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }

  return doRequestAxios('/v2/user/profile/update', requestOptions)
}

function getUserExperience(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/experience/get', requestOptions)
}

function addUserExperience(organization, role, startDate, endDate, ctaPopup) {
  const params = {
    organization,
    role,
    start_date: startDate,
    end_date: endDate
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: params
  }
  return doRequestAxios('/v2/user/profile/experience/add', requestOptions)
}

function updateUserExperience(experienceId, organization, role, startDate, endDate, ctaPopup) {
  const params = {
    id: experienceId,
    organization,
    role,
    start_date: startDate,
    end_date: endDate
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/experience/update', requestOptions)
}

function deleteUserExperience(payload) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    params: payload
  }

  return doRequestAxios('/v2/user/profile/experience/delete', requestOptions)
}

function putInterest(interestIds, ctaPopup) {
  const params = {
    interest_ids: interestIds
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/interests/update', requestOptions)
}

function removeInterests(interestIds) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { interest_ids: interestIds.toString() }
  }
  return doRequestAxios('/v2/user/profile/interests/remove', requestOptions)
}

function addInterest(interestIds) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { interest_ids: interestIds.toString() }
  }
  return doRequestAxios('/v2/user/profile/interests/add', requestOptions)
}

function putProfilePicture(pictureId, organizationId, ctaPopup) {
  const params = { picture_id: pictureId, organization_id: organizationId }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/picture/update', requestOptions)
}

function putProfilePopup(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios('/v2/user/profile/information/update', requestOptions)
}

function getUserEducation(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/education/get', requestOptions)
}

function addUserEducation(payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/education/add', requestOptions)
}

function updateUserEducation(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }

  return doRequestAxios('/v2/user/profile/education/update', requestOptions)
}

function deleteUserEducation(payload) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/education/delete', requestOptions)
}

function getExpertiseList(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios('/v2/user/profile/expertise/get-expertise-list', requestOptions)
}

function updateExpertise(expertiseIds, ctaPopup) {
  const params = {
    ids_expertise: expertiseIds
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/expertise/update-users-expertise', requestOptions)
}

function saveCoverPicture(pictureId, organizationId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      picture_id: pictureId,
      organization_id: organizationId
    }
  }
  return doRequestAxios('/v2/user/profile/cover-picture/save', requestOptions)
}

function getPromptList() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios('/v2/user/profile/prompt/list', requestOptions)
}

function addPrompt(promptId, answer, ctaPopup) {
  const params = {
    id_prompt: promptId,
    answer
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/prompt/add', requestOptions)
}

function updatePrompt(userPromptId, answer, ctaPopup) {
  const params = {
    id_prompt_user: userPromptId,
    answer
  }
  if (ctaPopup) {
    params.cta_popup = ctaPopup
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios('/v2/user/profile/prompt/update', requestOptions)
}

function deletePrompt(payload) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios('/v2/user/profile/prompt/delete', requestOptions)
}

function likeOrDislikePrompt(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios('/v2/user/profile/prompt/like', requestOptions)
}
